import { getIconActionDefTemplates } from "./getIconActionDefTemplates";

/**
 * Function to process the action definition of an icon action. It looks for the icon template based on the action name and merges the icon properties,
 * overriding the default values with the ones provided in the action definition.
 * @param {Object} actionDef The action definition of the icon action.
 * @param {Function} t The translation function from i18next.
 * @returns {Object} The processed action definition.
 */
export const processIconActionDef = (actionDef, t) => {
  const iconTemplates = getIconActionDefTemplates(t);
  const iconTemplate =
    iconTemplates.find((template) => template.name === actionDef.name) ?? {};
  return {
    ...iconTemplate,
    ...actionDef,
    iconProps: {
      ...iconTemplate.iconProps,
      ...actionDef.iconProps,
    },
  };
};
